<div class="stripe-wrapper">
    <div id="card-info" #cardInfo></div>

    <div id="card-errors" role="alert" *ngIf="error">{{ error }}</div>
</div>
<div class="row m-t-sm stripe-submit-button-row">
    <div class="col-md-12">
        <button class="pull-right btn btn-primary"
                (click)="applyCard()"
                [disabled]="buttonDisabled"
                id="confirmStripeCreditCard"
                type="button">
            Use This Card
        </button>
    </div>
</div>



// WEBPACK FOOTER //
// /app/src/app/components/stripe-payment/stripe-payment.component.html